import { Button, CCheckbox, CInputControl } from "core/components/form-controls";
import AppLayout from "core/layouts/AppLayout";
import PageHeader from "core/components/Header/PageHeader";
import { useCustomNavigate } from "core/hooks/useCustomNavigate";
import { useFormikCustom } from "core/hooks/useFormikCustom";
import { getFieldInputProps } from "core/utils/form";
import { _t } from "core/language";
import BottomNavigation from "core/layouts/BottomNavigation";
import CDialog from "core/components/CDialog";
import { useEffect, useState } from "react";
import API from "core/networks/API";
import { API_LEAVE_MEMBERSHIP, API_VERIFY_PASSWORD } from "../api";
import { useDispatch, useSelector } from "react-redux";
import * as action from "modules/Auth/store/actions";
import { useUser } from "modules/Auth/hooks";
import { hideBottomButtonInputFocus } from "core/utils/helper";
import { validationSchemaConfirmPasswordToLeave } from "modules/Auth/pages/Auth.config";
import { TypeUserLogin } from "core/constants";
import { useRecipe } from "modules/Ingredients/hooks/recipe";
import { resetImages } from "core/store/upload/actions";
import { resetCountCart } from "modules/Carts/store/actions";
import { LOGOUT_SUCCESS } from "modules/Auth/store/types";
import { RouterName } from "core/router";

const LeaveMembership = () => {
  const { resetRecipes } = useRecipe()
  const navigate = useCustomNavigate();
  const dispatch = useDispatch();
  const { userInfo } = useUser()
  const auth = useSelector((state: any) => state.Auth);
  const formik = useFormikCustom({
    initialValues: {
      password: "",
      agreeRole: false,
      validSubmit: true,
    },
    enableReinitialize: true,
    validationSchema: validationSchemaConfirmPasswordToLeave,
    validateOnMount: false, // Prevent validation on page load (default behavior)
    validateOnChange: false, // Validate on field changes
    validateOnBlur: false,   // Validate when a field is blurred
    onSubmit(values, formikHelpers) {
      handleSubmitComfirmPassword()
      setTimeout(() => {
        formikHelpers.setSubmitting(false)
      }, 2000)
    },
  });
  const [stateDialog, setStateDialog] = useState(false);
  const [activeLeave, setActiveLeave] = useState(false);

  useEffect(() => {
    hideBottomButtonInputFocus()
    resetRecipes();
  }, [])

  useEffect(() => {
    if ([LOGOUT_SUCCESS].includes(auth?.type) && activeLeave) {
        navigate(RouterName.MAIN)
    }
  }, [auth?.type]);

  // alert(JSON.stringify(userInfo))

  useEffect(() => {
    let validSubmit = true
    if (userInfo?.type && userInfo?.type === 'sns') {
      if (formik.values.agreeRole) {
        validSubmit = false
      }
    } else {
      if (formik.values.password && formik.values.agreeRole) {
        validSubmit = false
      }
    }
    formik.setValues((pre) => ({
      ...pre,
      validSubmit: validSubmit,
    }))
  }, [formik.values.agreeRole, formik.values.password])

  const handleGoBack = () => {
    navigate(-1)
  }

  const handleSubmitComfirmPassword = async () => {
    const dataRequest = {
      password: formik.values.password,
    }

    try {
      const { data: response } = await API.post(`${API_VERIFY_PASSWORD}`, dataRequest)
      if (response && response?.code === 200) {
        setStateDialog(true)
      }
    } catch (e: any) {
      // let msgError = e?.response?.data?.msg || 'ERROR SERVER'
      if (e?.response?.data?.code === 400) {
        formik.setErrors({ password: _t('auth.MI_02_MSG_01') })
      }
      if (e?.response?.data?.code === 422) {
        // let msgError = e?.response?.data?.errors[0]?.error || 'ERROR SERVER'
        formik.setErrors({ password: _t('auth.MI_02_MSG_01') })
      }
    }
  }

  const handleLeaveMembership = async () => {

    try {
      const { data: response } = await API.post(`${API_LEAVE_MEMBERSHIP}`, {})
      if (response && response?.code === 200) {
        setStateDialog(true)
      }
    } catch (e: any) {
      const msgError = e?.response?.data?.msg || 'ERROR SERVER'
      if (e?.response?.data?.code === 400) {
        formik.setErrors({ password: msgError })
      }
      if (e?.response?.data?.code === 422) {
        const msgError = e?.response?.data?.errors[0]?.error || 'ERROR SERVER'
        formik.setErrors({ password: msgError })
      }
    }
  }

  const handleSubmitLeaveMember = () => {
    // @ts-ignore
    window.webviewResponeLanguage({ lang: (window as any)._APP_LANG });
    dispatch(action.logOutRequest());
    setActiveLeave(true)
    handleLeaveMembership()
    dispatch(resetImages())
    dispatch(resetCountCart())
    if(userInfo?.type && userInfo?.type === TypeUserLogin.SNS) {
      // @ts-ignore
      window.webViewRequestLogout(auth?.token)
    }
  };


  const handleSubmit = (e: any) => {
    const { onSubmit } = formik;
    if (userInfo?.type && userInfo?.type === 'sns') {
      e.preventDefault()
      setStateDialog(true)
    }else {
      onSubmit(e)
    }
  };

  return (
    <AppLayout className={"login-client-page"}>
      <PageHeader className='fixed w-full z-100 bg-white' title={_t('auth.LeaveMembership')} handleGoBack={handleGoBack} />
      <div className="px-4 pt-[43px]" />
      <div className="pb-[150px]">
        <section className="flex flex-wrap gap-2.5 content-center items-center px-4 pt-[30px] ">
          <div className="flex flex-col self-stretch my-auto rounded-lg">
            <h2 className="self-start text-base font-medium tracking-tighter text-neutral-900 text-[16px]">
              {_t('auth.LabelCancelMembership')}
            </h2>
            <p className="mt-2 text-[11px] tracking-tight">
              {_t('auth.LabelBeforeLeaveYouCheckedContent')}
            </p>
            <div className="flex flex-wrap justify-center content-center items-center px-3.5 pl-[20px] py-5 mt-5 text-[13px] tracking-tighter leading-5 rounded-lg bg-zinc-100">
              <p className="
                flex-1 shrink 
                gap-2 
                self-stretch 
                my-auto 
                min-w-[240px] 
                relative
                pl-[15px]
                before:content-[''] before:block 
                before:absolute 
                before:top-[9px] 
                before:top-0 
                before:left-0 
                before:w-[4.25px] 
                before:h-[4.5px] 
                before:bg-[#333333] 
                before:rounded-full text-[13px]"
              >
                {_t('auth.LabelAfterLeaveAllInfoWillRemove')}
              </p>
            </div>
          </div>
        </section>
        <form onSubmit={handleSubmit} className="flex flex-col px-4 pt-[30px] w-full ">
          {userInfo?.type && userInfo?.type !== 'sns' &&
            <div className="min-h-[250px]">
              <CInputControl
                className=" min-h-[auto]"
                label={_t('auth.LabelConfirmPasswordToLeaveMemberShip')}
                error=""
                maxLength={200}
                type="password"
                placeholder={''}
                {...getFieldInputProps(formik, 'password')}
              />
              <span className="text-[11px] block mt-[5px]">{_t('auth.LabelConfirmPasswordMeansYouAgreeAllContent')}</span>
            </div>}
          <div className="flex flex-wrap justify-center mb-[42px]">
            <CCheckbox
              className=""
              label={_t('auth.LabelIHaveReadAndAgreeContent')}
              checked={formik.values.agreeRole}
              onChange={(value: boolean) => {
                formik.setValues((pre) => ({
                  ...pre,
                  agreeRole: value,
                }));
              }}
            />
          </div>
          <div className="bg-white bottom-btn fixed left-0 bottom-[60px] w-full px-4">

            <Button
              disabled={formik.values.validSubmit}
              size="lg" type="submit" label={_t('auth.ToUnsubscribe')}
              classBtn="w-full mb-[50px] font-medium"
            />
          </div>
        </form>
      </div >
      <CDialog
        open={stateDialog}
        closeText={_t('menu.CloseLeave')}
        submitText={_t('menu.OkLeave')}
        handleSubmit={handleSubmitLeaveMember}
        closeModal={() => { setStateDialog(false) }}
        classNamechildren={'pb-[20px]'}
      >
        <p className="text-sm font-medium ">{_t('auth.LabelAreYouSureLeaveMembership')}</p>
        <span className="text-[11px] text-[#333333]">{_t('auth.LabelIfLeaveMembershipAllInfoWillRemove')}</span>
      </CDialog>
      <BottomNavigation activeIndex={5} onNavigateChange={resetRecipes} />
    </AppLayout >
  );
};

export default LeaveMembership;
